var map = {
	"./ar-SA.json": [
		59304,
		59304
	],
	"./es-ES.json": [
		33977,
		33977
	],
	"./fa-IR.json": [
		74149,
		74149
	],
	"./fr-CA.json": [
		97553,
		97553
	],
	"./fr-FR.json": [
		26361,
		26361
	],
	"./ko-KR.json": [
		32078,
		32078
	],
	"./pt-PT.json": [
		74373,
		74373
	],
	"./ru-RU.json": [
		14431,
		14431
	],
	"./vi-VN.json": [
		54946,
		54946
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14995;
module.exports = webpackAsyncContext;